const translations = {
  postcoderoosregeling: 'deelname postcoderoosregeling',
  edit_amount: 'termijnbedrag aanpassen',
  usage: 'verbruik inzien',
  payment_method: 'betaalmogelijkheden',
  meter_readings: 'meterstanden doorgeven',
  annual_account: 'jaarrekening',
  digital: 'digitaal',
  free: 'gratis',
  mail: 'per post',
  online: 'online omgeving',
  phone: 'telefonisch',
  app: 'via app',
  automatic: 'automatische incasso',
  acceptgiro: 'overschrijven',
  electricity: 'stroom',
  gas: 'gas',
  month: 'maand',
  year: 'jaar',
  bio: 'biomass',
  kern: '',
  kolen: '',
  overig: '',
  water: '',
  zon: 'sun',
  true: 'Ja',
  false: 'Nee',
  total: 'Totaal',
  monthlyAmount: 'Maandbedrag',
  monthlyCosts: 'Maandelijkse kosten',
  yearlyAmount: 'Jaarbedrag',
  yearlyCosts: 'Jaarlijkse kosten',
};

function getLabel(val = ''): string {
  return translations[val] || val;
}
function getLabelTopThree(val = ''): string {
  return val === 'month' ? 'per maand' : 'per jaar';
}

export { getLabel, getLabelTopThree };
